import utils from '../../modules/utils';

export default (shouldLowerCasePaymentType = true) => {
  let paymentType = window?.start?.selectedPaymentMethod;
  if (shouldLowerCasePaymentType) {
    paymentType = paymentType?.toLowerCase();
  } else {
    paymentType = paymentType?.toUpperCase();
  }
  
  const isExpress = !!(utils.fn.getURIParams(window.location.search)?.app === 'express');

  if (isExpress) {
    return `${paymentType}-express`;
  }
  
  return paymentType;
};
